import { post, get, upload } from '@/api/request'
import { PaginationResponse, PaginationParams } from '@/api/base'

// 举报类型
export enum ReportType {
  COUNTERFEIT = 'counterfeit', // 假冒产品
  QUALITY = 'quality', // 质量问题
  PRICE = 'price', // 价格欺诈
  OTHER = 'other' // 其他问题
}

// 举报状态
export enum ReportStatus {
  PENDING = 'pending', // 待处理
  PROCESSING = 'processing', // 处理中
  RESOLVED = 'resolved', // 已解决
  REJECTED = 'rejected' // 已拒绝
}

// 举报请求参数
export interface ReportParams {
  brandId: number
  brandName: string
  // type: ReportType
  productName: string
  purchaseDate?: string
  purchaseChannel?: string
  problemDescription: string
  // evidencePhotos?: string[]
  isAnonymous: number
  contactName?: string
  contactPhone: string
}

export interface ReportProcess {
  id: number,
  complaintId?: number
  memberCode?: string
  operatorName?: string
  actionType?: number
  actionDescription?: string
  remark?: string
  createTime?: string
}
// 举报记录
export interface ReportRecord {
  code: string
  id: number
  brandId: number
  brandName: string
  // type: ReportType
  productName: string
  purchaseDate?: string
  purchaseChannel?: string
  problemDescription: string
  // evidencePhotos?: string[]
  isAnonymous: number
  contactName?: string
  contactPhone: string
  processingStatus?: number
  processingResult?: string
  processLogs?: ReportProcess[]
}

/**
 * 提交举报
 */
export const submitReport = (params: ReportParams) => {
  return post<ReportRecord>('/authenti-guard/v1/api/anti-counterfeit-complaint', params)
}

/**
 * 上传举报证据图片
 */
export const uploadEvidence = (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return upload<string>('/reports/upload', formData)
}

/**
 * 获取举报列表
 */
export const queryReportList = (params: PaginationParams = { page: 1, size: 10 }) => {
  return get<PaginationResponse<ReportRecord>>('/api/anti-counterfeit-complaint/list', params)
}

/**
 * 获取举报详情
 */
export const queryReportDetail = (reportCode: string) => {
  return get<ReportRecord>(`/authenti-guard/v1/api/anti-counterfeit-complaint/${reportCode}`)
}

/**
 * 撤销举报
 */
export const cancelReport = (reportId: number) => {
  return post(`/reports/${reportId}/cancel`)
}
